// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"4902f957","389":"05fc4d26","455":"455f7d69","502":"f9945680","977":"8e037608"}[chunkId] + ".chunk.js";
};